import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import CustomButton from '../../../components/buttons/CustomButton';
import { formatCurrency, roundedFieldSx } from './budgetFormat';
import styles from './BudgetSummary.module.css';

/** Resumo fixo ao lado: subtotal, desconto, total e o botão que abre a prévia. */
function BudgetSummary({ itemCount, subtotal, discount, total, onDiscountChange, onGenerate }) {
  return (
    <aside className={styles.card}>
      <header className={styles.header}>
        <span className={styles.icon}><CalculateOutlinedIcon /></span>
        <div className={styles.titleBlock}>
          <h3 className={styles.title}>Resumo</h3>
          <span className={styles.subtitle}>
            {itemCount ? `${itemCount} ${itemCount === 1 ? 'item' : 'itens'} no orçamento` : 'Nenhum item ainda'}
          </span>
        </div>
      </header>

      <div className={styles.rows}>
        <div className={styles.row}>
          <span className={styles.label}>Subtotal</span>
          <span className={styles.value}>{formatCurrency(subtotal)}</span>
        </div>

        <div className={styles.row}>
          <span className={styles.label}>Desconto</span>
          <TextField
            size="small"
            type="number"
            sx={{ ...roundedFieldSx, width: 140 }}
            inputProps={{ min: 0, step: 0.01, 'aria-label': 'Desconto em reais' }}
            InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
            value={discount}
            onChange={(e) => onDiscountChange(e.target.value)}
          />
        </div>
      </div>

      <div className={styles.total}>
        <span className={styles.totalLabel}>Valor total</span>
        <span className={styles.totalValue}>{formatCurrency(total)}</span>
      </div>

      <CustomButton
        label="Gerar orçamento"
        style="primary"
        variant="contained"
        icon={<PictureAsPdfOutlinedIcon />}
        onClick={onGenerate}
        className={styles.generate}
      />
      <span className={styles.hint}>Você confere a prévia antes de salvar o PDF.</span>
    </aside>
  );
}

export default BudgetSummary;
